<div class="exception-body notfound">
  <div class="exception-content">
    <div class="exception-title">404</div>
    <div class="exception-detail">Page Not Found</div>
    <p>The page you are looking for does not exist.</p>
    <a routerLink="/" class="btn btn-primary">Go to Home</a>
  </div>
</div>
